import React, { useEffect, useState } from 'react'

const ExportWarningModal = ({
  show,
  storageKey = "hideImportExportWarning",
  articleUrl = null,
  onClose,
  onConfirm,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false)

  useEffect(() => {
    if (show) {
      setDontShowAgain(false)
    }
  }, [show])

  if (!show) return null

  const continueHandler = () => {
    if (dontShowAgain) {
      try {
        localStorage.setItem(storageKey, "true")
      } catch (err) {
        console.log(err)
      }
    }

    onConfirm()
  }

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.45)" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Informacja</h5>
            <button type="button" className="close" aria-label="Zamknij" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <p className="mb-3">
              Aby uniknąć błędów podczas importu, przed edycją arkusza zapoznaj się z artykułem{" "}
              <strong>
                {articleUrl ? (
                  <a
                    className="link-primary"
                    href={articleUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Importy i eksporty Dashboard
                  </a>
                ) : (
                  <span>Importy i eksporty Dashboard</span>
                )}
              </strong>
              .
            </p>

            <div className="form-check">
              <input
                id="exportWarningDontShowAgain"
                type="checkbox"
                className="form-check-input"
                checked={dontShowAgain}
                onChange={(event) => setDontShowAgain(event.target.checked)}
              />
              <label className="form-check-label checkbox-trasnlate" htmlFor="exportWarningDontShowAgain">
                Nie pokazuj ponownie
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Anuluj
            </button>
            <button type="button" className="btn btn-primary" onClick={continueHandler}>
              Kontynuuj
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExportWarningModal